import CryptoJS from 'crypto-js'
import FileSaver from 'file-saver';
import { ConvertBanner, ConvertBannerEstatico, ConvertBannerDynamic } from '../helpers/exportBanner';
import imageCompression from 'browser-image-compression';
import JSZip from 'jszip';
import * as htmlToImage from 'html-to-image';
import { ConvertTimeline } from './exportVideo'
import * as XLSX from 'xlsx';
import { base64ToBlob } from './exportBanner';

function getCurrenttime() {
  const currentDate = new Date();
  const currentDayOfMonth = currentDate.getDate();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const currentHour = currentDate.getHours();
  const currentMinutes = currentDate.getMinutes();
  const currentSeconds = currentDate.getSeconds();
  return`${currentYear}${currentMonth}${currentDayOfMonth}${currentHour}${currentMinutes}${currentSeconds}`;
}

export async function SaveReanimateFile(master, assets, listaBanners, save = true) {
  try {
    const dateString = getCurrenttime();
    var banner = JSON.parse(JSON.stringify(master));
    const steps = banner.elements[banner.elements.length - 1].step;
    var listAssets = JSON.parse(JSON.stringify(assets));
    
    try {
      if (!listAssets || listAssets.length === 0 || listAssets === null || listAssets === undefined || listAssets === "undefined") {
        listAssets = [];
        master.elements.forEach(element => {
          const index = listAssets.findIndex(obj => obj.uuid === element.properties.asset);
          if (index === -1) {
            if (element.properties.background) {
              listAssets.push({
                uuid: element.properties.asset,
                data: element.properties.background
              });
            } else if (element.properties.originalBackground) {
              listAssets.push({
                uuid: element.properties.asset,
                data: element.properties.originalBackground
              });
            } else if (element.properties.blob) {
              convertBlobToBase64(base64ToBlob(element.properties.blob)).then((b64) => {
                listAssets.push({
                  uuid: element.properties.asset,
                  data: b64
                });
              });
            }
          }
        });  
      }
    } catch (error) {
      console.log('Error ao processar assets com lista vazia', error);
    }

    for (var i = 0; i < banner.elements.length; i++) {
      const element = banner.elements[i];
      element.enabled = true;
      if (element.stepout > steps || element.fixo) element.out = false;
      else element.out = true;
      var originalBG = element.properties.originalBackground;
      if (element.reduce) {
        originalBG = await resizedataURL(originalBG, element.properties.width * element.properties.scale / 100, element.properties.height * element.properties.scale / 100);
      }
      if (banner.optimize < 100) {
        element.properties.background = await Compress(originalBG, banner.optimize);
      }
    }
    if (banner.width === listaBanners.master.width && banner.height === listaBanners.master.height) {
      listaBanners.master = banner;
    } else {
      for (var j = 0; j < listaBanners.listaReplicas.length; j++) {
        if (banner.width === listaBanners.listaReplicas[j].width && banner.height === listaBanners.listaReplicas[j].height) {
          listaBanners.listaReplicas[j] = banner;
        }
      }
    }
    listaBanners.master.elements.forEach(element => {
      element.properties.background = "";
      element.properties.originalBackground = "";
    });

    listaBanners.master.html = '';
    let lista = JSON.stringify(listaBanners.master);

    var fileName = `${listaBanners.master.nome.replace(".rean", "")}_${dateString}.rean`;
    var file = "<versao>" + listaBanners.master.versao +"</versao>";
    
    file += "<master>";
    file += lista;
    file += "</master>";
    listaBanners.listaReplicas.forEach(replica => {
      file += "<replica>";
      replica.html = '';
      replica.elements.forEach(element => {
        element.properties.background = "";
        element.properties.originalBackground = "";
      });
      file += JSON.stringify(replica);
      file += "</replica>";
    });

    console.log('listAssets')
    console.log(listAssets)
    
    file += "<assets>";
    file += JSON.stringify(listAssets);
    file += "</assets>";
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(file), '%G@g$#@FDcxzHJd234@#%').toString();
    var blob = new Blob([ciphertext], {type: "text/plain;charset=utf-8"});
    //SaveFileCookie(master, listaReplicas)

    if (save) FileSaver.saveAs(blob, fileName);
    else return blob;
  } catch (error) {
    console.log('error')
    console.log(error)
  }
}


export function convertBlobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}


export async function Compress(background, quality) {
  let bg = background;  
  let format = bg.split('/')[1].split(';')[0];
  if(format.toLowerCase() !== 'gif'){    
    var ext = "png";
    try {
      ext = background.split(";base64")[0].replace("data:image/","");
    } catch { }
    var file = await urltoFile(background, 'hello.${ext}',`image/${ext}`);
    var options = {
      initialQuality: quality / 100
    };
    var image = await imageCompression(file, options); 
    var b64 = await blobToBase64(image);
    return b64;
  }
   else return bg
}



function urltoFile(url, filename, mimeType){
  return (fetch(url)
      .then(function(res){return res.arrayBuffer();})
      .then(function(buf){return new File([buf], filename,{type:mimeType});})
  );
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export async function SaveHTML(master) {
  try {
    var banner = JSON.parse(JSON.stringify(master));
    for (var i = 0; i < banner.elements.length; i++) {
      const element = banner.elements[i];
      if (banner.optimize < 100 && element.properties.background) {
        var originalBG = element.properties.originalBackground;
        if (element.reduce) {
          originalBG = await resizedataURL(originalBG, element.properties.width * element.properties.scale / 100, element.properties.height * element.properties.scale / 100);
        }
        element.properties.background = await Compress(originalBG, banner.optimize);
      }
    }
    var html = ConvertBanner(banner);
    return html;
  } catch (error) {  }
}

export async function SaveEstatico(master) {
  try {
    var banner = JSON.parse(JSON.stringify(master));
    for (var i = 0; i < banner.elements.length; i++) {
      const element = banner.elements[i];
      if (banner.optimize < 100 && element.properties.background) {
        element.properties.background = await Compress(element.properties.originalBackground, banner.optimize);
      }
    }
    var html = ConvertBannerEstatico(banner);
    return html;
  } catch (error) { console.log(error) }
}

export function GetBannerSize(html) {
  var myblob = new Blob([html], {
      type: 'text/plain'
  });
  return (myblob.size / 1024).toFixed(0);
}

export async function DownloadPackHTML(banner, assets, listaBanners, backupFormat) {
  try {
    const dateString = getCurrenttime();
    var zip = new JSZip();
  
    const image = await PrintElement();
    if (backupFormat === 'webp') image = await convertBase64PngToWebp(image);
    const blobimage = dataURItoBlob(image);
    var filename = `${banner.width}x${banner.height}`;
    var html = await SaveHTML(banner);

    zip.file(filename + `.${backupFormat.toString()}`, blobimage);
    zip.folder(filename + "_DCM").file(filename + ".html", html);  
    var savedFile = await SaveReanimateFile(banner, assets, listaBanners, false);
    zip.file(`${banner.nome}_${dateString}.rean`, savedFile);
    zip.generateAsync({type: "blob"}).then(function(content) {
      FileSaver.saveAs(content, `pack_${dateString}.zip`);
    });
    return true;

  } catch { return false; }
}

export async function DownloadPackEstatico(banner, assets, listaBanners, backupFormat) {
  const currentDate = new Date();
  const currentDayOfMonth = currentDate.getDate();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const currentHour = currentDate.getHours();
  const currentMinutes = currentDate.getMinutes();
  const currentSeconds = currentDate.getSeconds();
  const dateString = `${currentYear}${currentMonth}${currentDayOfMonth}${currentHour}${currentMinutes}${currentSeconds}`;

  let zip = new JSZip();
  let image = await PrintElement();
  if (backupFormat === 'webp') image = await convertBase64PngToWebp(image);
  const blobimage = dataURItoBlob(image);
  let filename = `${banner.nome}`;
  let html = await SaveEstatico(banner);
  banner.estatico = true;

  zip.file(filename + `.${backupFormat}`, blobimage);
  zip.folder(filename + "_DCM").file(filename + ".html", html);
  let savedFile = await SaveReanimateFile(banner, assets, listaBanners, false);
  zip.file(`${banner.nome}.rean`, savedFile);
  zip.generateAsync({type: "blob"}).then(function(content) {
    FileSaver.saveAs(content, `pack_${dateString}.zip`);
  });
}

function dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(',')[1]);
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  var blob = new Blob([ab], {type: mimeString});
  return blob;
}

export async function BackupDataBase() {
  var div = document.getElementById("backup-img-master");
  const width = div.style.width.replace('px', '');
  const height = div.style.height.replace('px', '');
  div.style.display = 'block';
  var b64 =  await toImage(div, 0, "jpeg");
  div.style.display = 'none';  
  var wantedWidth = width;
  var wantedHeight = height;
  if (width > 150 && height > 150) {
    const scale =  width / height;
    if (scale < 1) {
      wantedWidth = 150;
      wantedHeight = scale * 150;
    } else {
      wantedWidth = scale * 150;
      wantedHeight = 150;
    }
  }

  var compressedB64 = await resizedataURL(b64, wantedWidth, wantedHeight)
  return compressedB64;
}

export async function resizedataURL(datas, wantedWidth, wantedHeight)  {  
  return new Promise((resolve, _) => {
    // We create an image to receive the Data URI
    var img = document.createElement('img');
    // When the event "onload" is triggered we can resize the image.
    img.onload = function()
      {        
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
        resolve(canvas.toDataURL());
      };

    img.src = datas;
  });      
}

export async function PrintElement(type = 'png') {
  const minimumSize = 40000;
  var div = document.getElementById("backup-img-master");
  div.style.display = 'block';
  var b64 =  await toImage(div, 1, "png");
  var compressedB64 = b64;
  var size = getBase64Size(compressedB64);
  div.style.display = 'none';
  if (size > minimumSize) {
    for (var i = 10; i > 0; i--) {
      compressedB64 = await Compress(b64, i * 10);
      size = getBase64Size(compressedB64);
      if (size < minimumSize) break;
    }
  }
  return compressedB64;
}

var getBase64Size = function (base64) {
  var n = base64.length;
  var last = base64[n - 2];
  var y = 1;
  if (last === "=") y = 2;
  var x = (n * (3/4)) - y;
  return x;
};

async function toImage(div, quality, type = "jpeg") {
  return new Promise((resolve) => {
    if (type === "jpeg") {
      htmlToImage.toJpeg(div, { quality: quality, pixelRatio: 1 })
      .then(function (dataUrl) {
        resolve(dataUrl);
      });      
    } else if (type === "png") {
      htmlToImage.toPng(div, { quality: 1, pixelRatio: 1 })
      .then(function (dataUrl) {
        resolve(dataUrl);
      });    
    }
    else{
      
    }
  })
}

async function convertBase64PngToWebp(base64Png) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Png;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject('Canvas context inválido');

      ctx.drawImage(img, 0, 0);
      const base64Webp = canvas.toDataURL('image/webp', 0.8); // qualidade de 0 a 1
      console.log(base64Webp)
      resolve(base64Webp);
    };

    img.onerror = (e) => {
      reject(e);
    }
  });
}


export function GetArrayTxtIndex(inicio, fim, file, inclusive = false, trim = false) {
  if (!file) return null;
  const saida = [];
  var aux = true;
  file = trim ? file.replaceAll(" ", "").replaceAll("\n", "") : file;
  var tempFile = file;
  if (!file) return null;
  while (aux) {
    const index = tempFile.indexOf(inicio);
    if (index === -1) { 
      aux = false;
      break;
    } else {
      tempFile = tempFile.slice(inclusive ? index : index + inicio.length, tempFile.length);
      file = tempFile;
      const indexCloseTag = tempFile.indexOf(fim);
      if (indexCloseTag === -1) {
        aux = false;
        break;
      } else {
        file = file.slice(0, inclusive ? indexCloseTag + fim.length  : indexCloseTag);
        saida.push(file);
        if (indexCloseTag + fim.length < tempFile.length) tempFile = tempFile.slice(indexCloseTag + fim.length, tempFile.length);
        else aux = false;
      }
    }
  }
  if (saida.length === 0) return [null];
  return saida;
}

export async function DownloadPackVideo(banner) {
  let html = ConvertTimeline(banner);
  var zip = new JSZip();
  var filename = `${banner.nome}`;
  zip.file(filename + ".html", html);
}

export async function DownloadPackDynamic(banner, listFonts) {
  let zip = new JSZip();
  var html = ConvertBannerDynamic(banner, listFonts);
  var filename = `${banner.width}x${banner.height}`;
  var blob = new Blob([html], { type: "text/plain;charset=utf-8" });
  const workbook = XLSX.utils.book_new();

  for (let i = 0; i < banner.elements.length; i++) {
    const element = banner.elements[i];
    if (element.dynamic && element.properties.background && element.id && !element.properties.text) {
      const imageBlob = dataURItoBlob(element.properties.background);
      zip.file(`${element.id}.png`, imageBlob);
    }
  }
  
  const w = [[], []];
  for (let i = 0; i < banner.elements.length; i++) {
    const element = banner.elements[i];
    if (element.dynamic) {
      w[0].push(element.id)
      if (element.properties.text) {
        w[1].push(element.properties.text.text);
      } else {
        w[1].push(element.id + ".png")
      }
    }
  }
  const worksheetData = w;
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  zip.file("dynamic_elements.xlsx", excelBuffer);

  zip.file(`${filename}.html`, blob);

  zip.generateAsync({ type: "blob" }).then(function (content) {
    FileSaver.saveAs(content, `dynamic_pack_${filename}.zip`);
  });

  return true;
}